import { getDefaultConfig, getDefaultWallets } from '@rainbow-me/rainbowkit';
import {
    argentWallet,
    imTokenWallet,
    ledgerWallet,
    okxWallet,
    oneKeyWallet,
    trustWallet,
    uniswapWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { lazaiTestnet } from './lazaiTestnetChain';
export const projectId = '71ac7d15601566d1f55053d770c8ef53';

const { wallets: defaultWallets } = getDefaultWallets();
const wallets = [
    ...defaultWallets,
    {
        groupName: 'Other',
        wallets: [
            argentWallet,
            trustWallet,
            ledgerWallet,
            okxWallet,
            imTokenWallet,
            uniswapWallet,
            oneKeyWallet,
        ],
    },
];

const chainConfig = {
    chains: [lazaiTestnet],
    appName: 'LazAI Generate DAT',
    projectId: projectId,
    wallets,
};

export default getDefaultConfig(chainConfig as any);
